import teamMember1 from 'url:../assets/images/team-member-1.webp';
import teamMember2 from 'url:../assets/images/team-member-2.webp';
import teamMember3 from 'url:../assets/images/team-member-3.webp';

import teamMember1Video from 'url:../assets/videos/team-member-1.mp4';
import teamMember2Video from 'url:../assets/videos/team-member-2.mp4';
import teamMember3Video from 'url:../assets/videos/team-member-3.mp4';

export type TeamMember = {
  id: number;
  image: string;
  video: string;
  name: string;
  role: string;
  linkedinUrl?: string;
};

export const TEAM_MEMBERS: TeamMember[] = [
  {
    id: 0,
    image: teamMember1,
    video: teamMember1Video,
    name: 'Samuel Roberts',
    role: 'Founder and CEO',
    linkedinUrl: 'https://www.linkedin.com/in/samuel-roberts-311ab2153/',
  },
  {
    id: 1,
    image: teamMember2,
    video: teamMember2Video,
    name: 'Longbo Kong',
    role: 'Lead Engineer',
    linkedinUrl: 'https://www.linkedin.com/in/longbo-kong-533a446b',
  },
  {
    id: 2,
    image: teamMember3,
    video: teamMember3Video,
    name: 'Mike Saraswat',
    role: 'Senior Advisor',
    linkedinUrl: 'https://www.linkedin.com/in/mikesaraswat/',
  },
];
